// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =====================================================
   E2E TRACKING - CANDIDATE FORM
   PART 3.1
===================================================== */

:root{
    --primary:#2563EB;
    --secondary:#4F46E5;
    --success:#10B981;
    --danger:#EF4444;
    --warning:#F59E0B;
    --bg:#F4F7FE;
    --card:#FFFFFF;
    --border:#E2E8F0;
    --text:#1E293B;
    --text-light:#64748B;



    --shadow-hover:
        0 20px 45px rgba(37,99,235,.16);
}

/* =====================================================
   PAGE
===================================================== */

.candidate-page{
    width:98%;
    display:flex;
    justify-content:center;
    align-items:flex-start;
    padding:0px;
    animation:pageFade .45s ease;
}

/* =====================================================
   CARD
===================================================== */

.candidate-card{
    width:980px;
    max-width:100%;
    /* height:760px; */
    max-height: 500PX;
    background:var(--card);
    border-radius:22px;
    overflow-y:auto;
    overflow-x:hidden;
    box-shadow:var(--shadow);
    transition:.35s;
    position:relative;
    scrollbar-width:none;
    -ms-overflow-style:none;
}

.candidate-card::-webkit-scrollbar{
    display:none;

}

.candidate-card:hover{
    box-shadow:var(--shadow-hover);
}

/* =====================================================
   HEADER
===================================================== */

.candidate-header{
    display:flex;
    justify-content:space-between;
    align-items:center;
    padding:10px;
    color:#fff;
    background:
        linear-gradient(
            135deg,
            #2563EB,
            #4F46E5
        );
    position:sticky;
    top:0;
    z-index:30;
}

.candidate-header::after{
    content:"";
    position:absolute;
    width:210px;
    height:210px;
    border-radius:50%;
    right:-80px;
    top:-120px;
    background: rgba(255,255,255,.08);
}

.candidate-header h2{
    font-size:24px;
    font-weight:700;
    margin:0;
    letter-spacing:.3px;
}

.candidate-header p{
    margin-top:8px;
    font-size:15px;
    opacity:.9;
}

.candidate-header-icon{
    width:50px;
    height:50PX;
    border-radius:20px;
    display:flex;
    justify-content:center;
    align-items:center;
    background:rgba(255,255,255,.15);
    backdrop-filter:blur(15px);
    font-size:24px;
    animation:floatIcon 3s ease infinite;
}

/* =====================================================
   FORM
===================================================== */

form{
    padding:6px;
}

/* =====================================================
   SECTION
===================================================== */

.section{
    margin-bottom:24px;
    background:#fff;
    border:1px solid var(--border);
    border-radius:18px;
    padding:14px;
    transition:.3s;
}

.section:hover{
    transform:translateY(-2px);
    box-shadow: 0 12px 28px rgba(37,99,235,.08);
}

/* =====================================================
   SECTION TITLE
===================================================== */

.section-title{
    display:flex;
    align-items:center;
    gap:12px;
    margin-bottom:22px;
    font-size:19px;
    font-weight:700;
    color:var(--text);
    position:relative;
    padding-bottom:14px;
}

.section-title svg{
    font-size:22px;
    color:var(--primary);
}

.section-title::after{
    content:"";
    position:absolute;
    bottom:0;
    left:0;
    width:70px;
    height:4px;
    border-radius:10px;
    background:
        linear-gradient(
            90deg,
            var(--primary),
            var(--secondary)
        );
}

/* =====================================================
   GRID
===================================================== */

.candidate-grid{
    display:grid;
    grid-template-columns:  repeat(3,minmax(280px,1fr));
    gap:12px;
}

/* =====================================================
   FORM GROUP
===================================================== */

.form-group{
    display:flex;
    flex-direction:column;
    margin-bottom:20px;
}

.form-group label{
    font-size:14px;
    font-weight:600;
    color:var(--text);
    margin-bottom:10px;
    letter-spacing:.3px;
}

/* =====================================================
   FIELD INFO
===================================================== */

.field-info{
    margin-top:8px;
    color:var(--text-light);
    font-size:13px;
}

/* =====================================================
   SMALL ERROR
===================================================== */

.form-group small{
    display:flex;
    align-items:center;
    gap:6px;
    margin-top:8px;
    color:var(--danger);
    font-size:13px;
    font-weight:500;
}

/* =====================================================
   ANIMATIONS
===================================================== */

@keyframes pageFade{
    from{
        opacity:0;
        transform:translateY(25px);
    }
    to{
        opacity:1;
        transform:translateY(0);
    }
}

@keyframes floatIcon{
    0%{
        transform:translateY(0);
    }
    50%{
        transform:translateY(-6px);
    }
    100%{
        transform:translateY(0);
    }

}

/* =====================================================
   PART 3.2
   INPUTS • SELECT • TEXTAREA
===================================================== */

/* INPUT CONTAINER */

.input-box{
    position:relative;
    display:flex;
    align-items:center;
    width:100%;
}

/* INPUT ICON */

.input-box svg{
    position:absolute;
    left:16px;
    top:50%;
    transform:translateY(-50%);
    color:#94A3B8;
    font-size:18px;
    transition:.3s;
    pointer-events:none;
    z-index:2;
}

/* INPUT */

.input-box input{
    width:100%;
    height:34px;
    border:1px solid var(--border);
    border-radius:8px;
    background:#fff;
    padding:0 18px 0 48px;
    font-size:15px;
    color:var(--text);
    outline:none;
    transition:all .30s ease;
}

/* SELECT */

.input-box select{
    width:100%;
    height:34px;
    border:1px solid var(--border);
    border-radius:8px;
    background:#fff;
    padding:0 18px 0 48px;
    font-size:15px;
    color:var(--text);
    outline:none;
    cursor:pointer;
    appearance:none;
    -webkit-appearance:none;
    transition:all .30s ease;
}

/* TEXTAREA WRAPPER */

.textarea-box{
    align-items:flex-start;
}

/* TEXTAREA ICON */

.textarea-icon{
    position:absolute;
    left:16px;
    top:18px !important;
    transform:none !important;
    color:#94A3B8;
    font-size:18px;
}

/* TEXTAREA */

.textarea-box textarea{
    width:100%;
    height:40px;
    resize:vertical;
    border:1px solid var(--border);
    border-radius:14px;
    background:#fff;
    padding:16px 18px 16px 48px;
    font-size:15px;
    line-height:1.7;
    color:var(--text);
    outline:none;
    transition:.30s;
    font-family:inherit;
}

/* REMARKS TEXTAREA */

.form-group textarea{
    width:100%;
    min-height:140px;
    border:1px solid var(--border);
    border-radius:14px;
    padding:16px;
    resize:vertical;
    font-size:15px;
    line-height:1.7;
    color:var(--text);
    outline:none;
    transition:.30s;
    font-family:inherit;

}

/* PLACEHOLDER */

.input-box input::placeholder,
.textarea-box textarea::placeholder,
.form-group textarea::placeholder{
    color:#94A3B8;
}

/* HOVER */

.input-box input:hover,
.input-box select:hover,
.textarea-box textarea:hover,
.form-group textarea:hover{
    border-color:#BFDBFE;
}

/* FOCUS */
.input-box input:focus,
.input-box select:focus,
.textarea-box textarea:focus,
.form-group textarea:focus{
    border-color:var(--primary);
    box-shadow:0 0 0 5px rgba(37,99,235,.12);
}

/* ICON COLOR ON FOCUS */

.input-box:focus-within svg{
    color:var(--primary);
}

/* ERROR INPUT */
.input-error input,
.input-error select,
.input-error textarea{
    border-color:var(--danger);
    box-shadow:0 0 0 4px rgba(239,68,68,.12);

}

/* REQUIRED STAR */
.required{
    color:var(--danger);
    margin-left:4px;
}

/* CHARACTER COUNTER */

.remarks-count{
    margin-top:8px;
    text-align:right;
    color:var(--text-light);
    font-size:13px;
}

/* DISABLED */

input:disabled,
textarea:disabled,
select:disabled{
    background:#F8FAFC;
    color:#94A3B8;
    cursor:not-allowed;
}

/* AUTOFILL */
input:-webkit-autofill{
    -webkit-box-shadow:0 0 0px 1000px white inset;
    -webkit-text-fill-color:var(--text);
}

/* LABEL ANIMATION */

.form-group label{
    transition:.25s;
}

.form-group:hover label{
    color:var(--primary);
}

/* SMOOTH FIELD APPEAR */

.form-group{
    animation:fieldFade .45s ease;
}

@keyframes fieldFade{
    from{
        opacity:0;
        transform:translateY(10px);
    }
    to{
        opacity:1;
        transform:translateY(0);
    }
}

/* MOBILE */

@media(max-width:768px){
    .candidate-grid{
        grid-template-columns:1fr;
    }

    .input-box input,
    .input-box select{
        height:50px;
    }
}

/* =====================================================
   PART 3.3
   RESUME UPLOAD
===================================================== */

/* Resume Upload Container */
.upload-box{
    width:100%;
    min-height:260px;
    border:2px dashed #3B82F6;
    border-radius:20px;
    background:linear-gradient(180deg, #F8FBFF, #EFF6FF);
    display:flex;
    justify-content:center;
    align-items:center;
    cursor:pointer;
    transition:all .35s ease;
    position:relative;
    overflow:hidden;
}

/* Background Glow */

.upload-box::before{
    content:"";
    position:absolute;
    inset:0;
    background:radial-gradient(circle at top right, rgba(59,130,246,.12), transparent 55%);
    opacity:0;
    transition:.35s;
}

.upload-box:hover{
    transform:translateY(-4px);
    border-color:var(--secondary);
    box-shadow:0 18px 45px rgba(37,99,235,.15);
}

.upload-box:hover::before{
    opacity:1;
}

/* Drag Active */

.upload-box.active{
    border-color:var(--success);
    background:#ECFDF5;
    transform:scale(1.01);
}

/* Upload Content */

.upload-content{
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    text-align:center;
    z-index:2;
    padding:35px;
}

/* Upload Circle */

.upload-circle{
    width:82px;
    height:82px;
    border-radius:50%;
    display:flex;
    justify-content:center;
    align-items:center;
    background:linear-gradient(135deg, var(--primary), var(--secondary));
    color:#fff;
    font-size:34px;
    margin-bottom:22px;
    animation:uploadFloat 3s ease infinite;
}

/* Upload Heading */

.upload-content h3{
    font-size:22px;
    font-weight:700;
    color:var(--text);
    margin-bottom:10px;
}

/* Upload Description */

.upload-content p{
    color:var(--text-light);
    font-size:15px;
    margin-bottom:6px;

}

/* Browse Text */

.upload-content span{

    color:var(--primary);

    font-weight:600;

    font-size:14px;

}

/* Selected File */

.selected-file{

    margin-top:24px;

    display:flex;

    align-items:center;

    gap:10px;

    background:#fff;

    border:1px solid #D1FAE5;

    color:var(--success);

    padding:14px 20px;

    border-radius:14px;

    box-shadow:0 8px 20px rgba(16,185,129,.08);

    font-weight:600;

    max-width:100%;

    word-break:break-word;

}

.selected-file svg{

    font-size:20px;

}

/* Error Message */

.upload-content small{

    display:flex;

    align-items:center;

    gap:8px;

    margin-top:18px;

    color:var(--danger);

    font-size:14px;

    font-weight:600;

}

/* =====================================================
   CURRENT RESUME CARD
===================================================== */

.current-resume{

    margin-bottom:22px;

    border:1px solid var(--border);

    border-left:5px solid var(--primary);

    border-radius:16px;

    background:#fff;

    padding:18px 22px;

    transition:.3s;

}

.current-resume:hover{

    transform:translateY(-2px);

    box-shadow:0 10px 25px rgba(37,99,235,.08);

}

.resume-left{

    display:flex;

    align-items:center;

    gap:16px;

}

.resume-left svg{

    font-size:28px;

    color:var(--success);

}

.resume-left h4{

    margin:0;

    color:var(--text);

    font-size:17px;

    font-weight:700;

}

.resume-left span{

    display:block;

    margin-top:5px;

    color:var(--text-light);

    font-size:14px;

    word-break:break-all;

}

/* =====================================================
   UPLOAD FLOAT ANIMATION
===================================================== */

@keyframes uploadFloat{

    0%{

        transform:translateY(0);

    }

    50%{

        transform:translateY(-8px);

    }

    100%{

        transform:translateY(0);

    }

}

/* =====================================================
   MOBILE
===================================================== */

@media(max-width:768px){

    .upload-box{

        min-height:220px;

    }

    .upload-circle{

        width:68px;

        height:68px;

        font-size:28px;

    }

    .upload-content h3{

        font-size:19px;

    }

}

/* =====================================================
   PART 3.4
   FOOTER • BUTTONS • LOADER • RESPONSIVE
===================================================== */

/* ==========================
   FOOTER
========================== */

.candidate-footer{

    position:sticky;

    bottom:0;

    background:#fff;

    padding:20px 28px;

    margin:30px -28px -28px;

    border-top:1px solid var(--border);

    display:flex;

    justify-content:flex-end;

    align-items:center;

    gap:16px;

    z-index:20;

}

/* ==========================
   BUTTONS
========================== */

.cancel-btn{

    min-width:150px;

    height:48px;

    border:1px solid var(--border);

    background:#fff;

    color:var(--text);

    border-radius:14px;

    font-size:15px;

    font-weight:600;

    cursor:pointer;

    transition:all .30s ease;

}

.cancel-btn:hover{

    background:#F8FAFC;

    border-color:#CBD5E1;

    transform:translateY(-2px);

}

.save-btn{

    min-width:190px;

    height:48px;

    border:none;

    border-radius:14px;

    background:linear-gradient(
        135deg,
        var(--primary),
        var(--secondary)
    );

    color:#fff;

    display:flex;

    justify-content:center;

    align-items:center;

    gap:10px;

    font-size:15px;

    font-weight:700;

    cursor:pointer;

    transition:all .30s ease;

    box-shadow:
        0 10px 25px rgba(37,99,235,.25);

}

.save-btn:hover{

    transform:translateY(-3px);

    box-shadow:
        0 18px 40px rgba(37,99,235,.35);

}

.save-btn:active{

    transform:scale(.98);

}

.save-btn:disabled{

    opacity:.7;

    cursor:not-allowed;

    transform:none;

}

/* ==========================
   LOADER
========================== */

.loader{

    width:18px;

    height:18px;

    border:2px solid rgba(255,255,255,.35);

    border-top:2px solid #fff;

    border-radius:50%;

    animation:spin .8s linear infinite;

}

@keyframes spin{

    from{

        transform:rotate(0deg);

    }

    to{

        transform:rotate(360deg);

    }

}

/* ==========================
   SMOOTH SCROLL
========================== */

.candidate-card{

    scroll-behavior:smooth;

}

/* Optional visible scrollbar */

.candidate-card::-webkit-scrollbar{

    width:8px;

}

.candidate-card::-webkit-scrollbar-track{

    background:#F8FAFC;

}

.candidate-card::-webkit-scrollbar-thumb{

    background:#CBD5E1;

    border-radius:10px;

}

.candidate-card::-webkit-scrollbar-thumb:hover{

    background:#94A3B8;

}

/* ==========================
   FADE-IN ANIMATION
========================== */

.section{

    animation:sectionFade .45s ease both;

}

.section:nth-child(2){

    animation-delay:.05s;

}

.section:nth-child(3){

    animation-delay:.10s;

}

.section:nth-child(4){

    animation-delay:.15s;

}

@keyframes sectionFade{

    from{

        opacity:0;

        transform:translateY(18px);

    }

    to{

        opacity:1;

        transform:translateY(0);

    }

}

/* ==========================
   RESPONSIVE
========================== */

@media (max-width:992px){

    .candidate-card{

        width:100%;

        height:calc(100vh - 40px);

        border-radius:18px;

    }

    .candidate-header{

        padding:24px;

    }

    .candidate-header h2{

        font-size:28px;

    }

}

@media (max-width:768px){

    .candidate-page{

        padding:12px;

    }

    .candidate-header{

        flex-direction:column;

        align-items:flex-start;

        gap:16px;

    }

    .candidate-header-icon{

        width:64px;

        height:64px;

        font-size:30px;

    }

    .candidate-grid{

        grid-template-columns:1fr;

    }

    .candidate-footer{

        flex-direction:column-reverse;

        align-items:stretch;

        gap:12px;

    }

    .cancel-btn,

    .save-btn{

        width:100%;

    }

}

@media (max-width:480px){

    form{

        padding:18px;

    }

    .section{

        padding:18px;

    }

    .candidate-header h2{

        font-size:24px;

    }

    .candidate-header p{

        font-size:13px;

    }

    .section-title{

        font-size:17px;

    }

}

/* ==========================
   BUTTON RIPPLE EFFECT
========================== */

.save-btn,

.cancel-btn{

    position:relative;

    overflow:hidden;

}

.save-btn::after,

.cancel-btn::after{

    content:"";

    position:absolute;

    width:0;

    height:0;

    background:rgba(255,255,255,.25);

    border-radius:50%;

    transform:translate(-50%,-50%);

    transition:width .5s,height .5s;

    left:50%;

    top:50%;

}

.save-btn:active::after,

.cancel-btn:active::after{

    width:320px;

    height:320px;

}

/* ==========================
   CARD HOVER
========================== */

.candidate-card{

    transition:transform .35s ease,

               box-shadow .35s ease;

}

.candidate-card:hover{

    transform:translateY(-3px);

}

/* ==========================
   FINISH
========================== */
.candidate-submit-error {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 18px 24px 0;
    padding: 12px 14px;
    border: 1px solid #fecaca;
    border-radius: 10px;
    background: #fef2f2;
    color: #b91c1c;
    font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/forms/CandidateForm.css"],"names":[],"mappings":"AAAA;;;uDAGuD;;AAEvD;IACI,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,oBAAoB;;;;IAIpB;uCACmC;AACvC;;AAEA;;uDAEuD;;AAEvD;IACI,SAAS;IACT,YAAY;IACZ,sBAAsB;IACtB,sBAAsB;IACtB,WAAW;IACX,4BAA4B;AAChC;;AAEA;;uDAEuD;;AAEvD;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;;AAEhB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;uDAEuD;;AAEvD;IACI,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV;;;;;SAKK;IACL,eAAe;IACf,KAAK;IACL,UAAU;AACd;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,UAAU;IACV,iCAAiC;AACrC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,UAAU;AACd;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,gCAAgC;IAChC,0BAA0B;IAC1B,cAAc;IACd,oCAAoC;AACxC;;AAEA;;uDAEuD;;AAEvD;IACI,WAAW;AACf;;AAEA;;uDAEuD;;AAEvD;IACI,kBAAkB;IAClB,eAAe;IACf,8BAA8B;IAC9B,kBAAkB;IAClB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,2CAA2C;AAC/C;;AAEA;;uDAEuD;;AAEvD;IACI,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,QAAQ;IACR,MAAM;IACN,UAAU;IACV,UAAU;IACV,kBAAkB;IAClB;;;;;SAKK;AACT;;AAEA;;uDAEuD;;AAEvD;IACI,YAAY;IACZ,mDAAmD;IACnD,QAAQ;AACZ;;AAEA;;uDAEuD;;AAEvD;IACI,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;uDAEuD;;AAEvD;IACI,cAAc;IACd,uBAAuB;IACvB,cAAc;AAClB;;AAEA;;uDAEuD;;AAEvD;IACI,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,cAAc;IACd,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB;;AAEA;;uDAEuD;;AAEvD;IACI;QACI,SAAS;QACT,0BAA0B;IAC9B;IACA;QACI,SAAS;QACT,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,uBAAuB;IAC3B;;AAEJ;;AAEA;;;uDAGuD;;AAEvD,oBAAoB;;AAEpB;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,UAAU;AACd;;AAEA,eAAe;;AAEf;IACI,iBAAiB;IACjB,SAAS;IACT,OAAO;IACP,0BAA0B;IAC1B,aAAa;IACb,cAAc;IACd,cAAc;IACd,mBAAmB;IACnB,SAAS;AACb;;AAEA,UAAU;;AAEV;IACI,UAAU;IACV,WAAW;IACX,8BAA8B;IAC9B,iBAAiB;IACjB,eAAe;IACf,qBAAqB;IACrB,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,wBAAwB;AAC5B;;AAEA,WAAW;;AAEX;IACI,UAAU;IACV,WAAW;IACX,8BAA8B;IAC9B,iBAAiB;IACjB,eAAe;IACf,qBAAqB;IACrB,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA,qBAAqB;;AAErB;IACI,sBAAsB;AAC1B;;AAEA,kBAAkB;;AAElB;IACI,iBAAiB;IACjB,SAAS;IACT,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,cAAc;AAClB;;AAEA,aAAa;;AAEb;IACI,UAAU;IACV,WAAW;IACX,eAAe;IACf,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;IACf,2BAA2B;IAC3B,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,mBAAmB;AACvB;;AAEA,qBAAqB;;AAErB;IACI,UAAU;IACV,gBAAgB;IAChB,8BAA8B;IAC9B,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,mBAAmB;;AAEvB;;AAEA,gBAAgB;;AAEhB;;;IAGI,aAAa;AACjB;;AAEA,UAAU;;AAEV;;;;IAII,oBAAoB;AACxB;;AAEA,UAAU;AACV;;;;IAII,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA,wBAAwB;;AAExB;IACI,oBAAoB;AACxB;;AAEA,gBAAgB;AAChB;;;IAGI,0BAA0B;IAC1B,wCAAwC;;AAE5C;;AAEA,kBAAkB;AAClB;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA,sBAAsB;;AAEtB;IACI,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;AAClB;;AAEA,aAAa;;AAEb;;;IAGI,kBAAkB;IAClB,aAAa;IACb,kBAAkB;AACtB;;AAEA,aAAa;AACb;IACI,6CAA6C;IAC7C,mCAAmC;AACvC;;AAEA,oBAAoB;;AAEpB;IACI,eAAe;AACnB;;AAEA;IACI,oBAAoB;AACxB;;AAEA,wBAAwB;;AAExB;IACI,6BAA6B;AACjC;;AAEA;IACI;QACI,SAAS;QACT,0BAA0B;IAC9B;IACA;QACI,SAAS;QACT,uBAAuB;IAC3B;AACJ;;AAEA,WAAW;;AAEX;IACI;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,WAAW;IACf;AACJ;;AAEA;;;uDAGuD;;AAEvD,4BAA4B;AAC5B;IACI,UAAU;IACV,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,oDAAoD;IACpD,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,wBAAwB;IACxB,iBAAiB;IACjB,eAAe;AACnB;;AAEA,oBAAoB;;AAEpB;IACI,UAAU;IACV,iBAAiB;IACjB,OAAO;IACP,sFAAsF;IACtF,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;IAC7B,0CAA0C;AAC9C;;AAEA;IACI,SAAS;AACb;;AAEA,gBAAgB;;AAEhB;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA,mBAAmB;;AAEnB;IACI,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,SAAS;IACT,YAAY;AAChB;;AAEA,kBAAkB;;AAElB;IACI,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,oEAAoE;IACpE,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA,mBAAmB;;AAEnB;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA,uBAAuB;;AAEvB;IACI,uBAAuB;IACvB,cAAc;IACd,iBAAiB;;AAErB;;AAEA,gBAAgB;;AAEhB;;IAEI,oBAAoB;;IAEpB,eAAe;;IAEf,cAAc;;AAElB;;AAEA,kBAAkB;;AAElB;;IAEI,eAAe;;IAEf,YAAY;;IAEZ,kBAAkB;;IAElB,QAAQ;;IAER,eAAe;;IAEf,wBAAwB;;IAExB,oBAAoB;;IAEpB,iBAAiB;;IAEjB,kBAAkB;;IAElB,0CAA0C;;IAE1C,eAAe;;IAEf,cAAc;;IAEd,qBAAqB;;AAEzB;;AAEA;;IAEI,cAAc;;AAElB;;AAEA,kBAAkB;;AAElB;;IAEI,YAAY;;IAEZ,kBAAkB;;IAElB,OAAO;;IAEP,eAAe;;IAEf,mBAAmB;;IAEnB,cAAc;;IAEd,eAAe;;AAEnB;;AAEA;;uDAEuD;;AAEvD;;IAEI,kBAAkB;;IAElB,8BAA8B;;IAE9B,oCAAoC;;IAEpC,kBAAkB;;IAElB,eAAe;;IAEf,iBAAiB;;IAEjB,cAAc;;AAElB;;AAEA;;IAEI,0BAA0B;;IAE1B,0CAA0C;;AAE9C;;AAEA;;IAEI,YAAY;;IAEZ,kBAAkB;;IAElB,QAAQ;;AAEZ;;AAEA;;IAEI,cAAc;;IAEd,oBAAoB;;AAExB;;AAEA;;IAEI,QAAQ;;IAER,iBAAiB;;IAEjB,cAAc;;IAEd,eAAe;;AAEnB;;AAEA;;IAEI,aAAa;;IAEb,cAAc;;IAEd,uBAAuB;;IAEvB,cAAc;;IAEd,oBAAoB;;AAExB;;AAEA;;uDAEuD;;AAEvD;;IAEI;;QAEI,uBAAuB;;IAE3B;;IAEA;;QAEI,0BAA0B;;IAE9B;;IAEA;;QAEI,uBAAuB;;IAE3B;;AAEJ;;AAEA;;uDAEuD;;AAEvD;;IAEI;;QAEI,gBAAgB;;IAEpB;;IAEA;;QAEI,UAAU;;QAEV,WAAW;;QAEX,cAAc;;IAElB;;IAEA;;QAEI,cAAc;;IAElB;;AAEJ;;AAEA;;;uDAGuD;;AAEvD;;4BAE4B;;AAE5B;;IAEI,eAAe;;IAEf,QAAQ;;IAER,eAAe;;IAEf,iBAAiB;;IAEjB,uBAAuB;;IAEvB,kCAAkC;;IAElC,YAAY;;IAEZ,wBAAwB;;IAExB,kBAAkB;;IAElB,QAAQ;;IAER,UAAU;;AAEd;;AAEA;;4BAE4B;;AAE5B;;IAEI,eAAe;;IAEf,WAAW;;IAEX,8BAA8B;;IAE9B,eAAe;;IAEf,iBAAiB;;IAEjB,kBAAkB;;IAElB,cAAc;;IAEd,eAAe;;IAEf,cAAc;;IAEd,wBAAwB;;AAE5B;;AAEA;;IAEI,kBAAkB;;IAElB,oBAAoB;;IAEpB,0BAA0B;;AAE9B;;AAEA;;IAEI,eAAe;;IAEf,WAAW;;IAEX,WAAW;;IAEX,kBAAkB;;IAElB;;;;KAIC;;IAED,UAAU;;IAEV,YAAY;;IAEZ,sBAAsB;;IAEtB,kBAAkB;;IAElB,QAAQ;;IAER,cAAc;;IAEd,eAAe;;IAEf,cAAc;;IAEd,wBAAwB;;IAExB;uCACmC;;AAEvC;;AAEA;;IAEI,0BAA0B;;IAE1B;uCACmC;;AAEvC;;AAEA;;IAEI,oBAAoB;;AAExB;;AAEA;;IAEI,UAAU;;IAEV,kBAAkB;;IAElB,cAAc;;AAElB;;AAEA;;4BAE4B;;AAE5B;;IAEI,UAAU;;IAEV,WAAW;;IAEX,sCAAsC;;IAEtC,yBAAyB;;IAEzB,iBAAiB;;IAEjB,kCAAkC;;AAEtC;;AAEA;;IAEI;;QAEI,sBAAsB;;IAE1B;;IAEA;;QAEI,wBAAwB;;IAE5B;;AAEJ;;AAEA;;4BAE4B;;AAE5B;;IAEI,sBAAsB;;AAE1B;;AAEA,+BAA+B;;AAE/B;;IAEI,SAAS;;AAEb;;AAEA;;IAEI,kBAAkB;;AAEtB;;AAEA;;IAEI,kBAAkB;;IAElB,kBAAkB;;AAEtB;;AAEA;;IAEI,kBAAkB;;AAEtB;;AAEA;;4BAE4B;;AAE5B;;IAEI,oCAAoC;;AAExC;;AAEA;;IAEI,oBAAoB;;AAExB;;AAEA;;IAEI,oBAAoB;;AAExB;;AAEA;;IAEI,oBAAoB;;AAExB;;AAEA;;IAEI;;QAEI,SAAS;;QAET,0BAA0B;;IAE9B;;IAEA;;QAEI,SAAS;;QAET,uBAAuB;;IAE3B;;AAEJ;;AAEA;;4BAE4B;;AAE5B;;IAEI;;QAEI,UAAU;;QAEV,yBAAyB;;QAEzB,kBAAkB;;IAEtB;;IAEA;;QAEI,YAAY;;IAEhB;;IAEA;;QAEI,cAAc;;IAElB;;AAEJ;;AAEA;;IAEI;;QAEI,YAAY;;IAEhB;;IAEA;;QAEI,qBAAqB;;QAErB,sBAAsB;;QAEtB,QAAQ;;IAEZ;;IAEA;;QAEI,UAAU;;QAEV,WAAW;;QAEX,cAAc;;IAElB;;IAEA;;QAEI,yBAAyB;;IAE7B;;IAEA;;QAEI,6BAA6B;;QAE7B,mBAAmB;;QAEnB,QAAQ;;IAEZ;;IAEA;;;;QAII,UAAU;;IAEd;;AAEJ;;AAEA;;IAEI;;QAEI,YAAY;;IAEhB;;IAEA;;QAEI,YAAY;;IAEhB;;IAEA;;QAEI,cAAc;;IAElB;;IAEA;;QAEI,cAAc;;IAElB;;IAEA;;QAEI,cAAc;;IAElB;;AAEJ;;AAEA;;4BAE4B;;AAE5B;;;;IAII,iBAAiB;;IAEjB,eAAe;;AAEnB;;AAEA;;;;IAII,UAAU;;IAEV,iBAAiB;;IAEjB,OAAO;;IAEP,QAAQ;;IAER,gCAAgC;;IAEhC,iBAAiB;;IAEjB,8BAA8B;;IAE9B,+BAA+B;;IAE/B,QAAQ;;IAER,OAAO;;AAEX;;AAEA;;;;IAII,WAAW;;IAEX,YAAY;;AAEhB;;AAEA;;4BAE4B;;AAE5B;;IAEI;;mCAE+B;;AAEnC;;AAEA;;IAEI,0BAA0B;;AAE9B;;AAEA;;4BAE4B;AAC5B;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB","sourcesContent":["/* =====================================================\r\n   E2E TRACKING - CANDIDATE FORM\r\n   PART 3.1\r\n===================================================== */\r\n\r\n:root{\r\n    --primary:#2563EB;\r\n    --secondary:#4F46E5;\r\n    --success:#10B981;\r\n    --danger:#EF4444;\r\n    --warning:#F59E0B;\r\n    --bg:#F4F7FE;\r\n    --card:#FFFFFF;\r\n    --border:#E2E8F0;\r\n    --text:#1E293B;\r\n    --text-light:#64748B;\r\n\r\n\r\n\r\n    --shadow-hover:\r\n        0 20px 45px rgba(37,99,235,.16);\r\n}\r\n\r\n/* =====================================================\r\n   PAGE\r\n===================================================== */\r\n\r\n.candidate-page{\r\n    width:98%;\r\n    display:flex;\r\n    justify-content:center;\r\n    align-items:flex-start;\r\n    padding:0px;\r\n    animation:pageFade .45s ease;\r\n}\r\n\r\n/* =====================================================\r\n   CARD\r\n===================================================== */\r\n\r\n.candidate-card{\r\n    width:980px;\r\n    max-width:100%;\r\n    /* height:760px; */\r\n    max-height: 500PX;\r\n    background:var(--card);\r\n    border-radius:22px;\r\n    overflow-y:auto;\r\n    overflow-x:hidden;\r\n    box-shadow:var(--shadow);\r\n    transition:.35s;\r\n    position:relative;\r\n    scrollbar-width:none;\r\n    -ms-overflow-style:none;\r\n}\r\n\r\n.candidate-card::-webkit-scrollbar{\r\n    display:none;\r\n\r\n}\r\n\r\n.candidate-card:hover{\r\n    box-shadow:var(--shadow-hover);\r\n}\r\n\r\n/* =====================================================\r\n   HEADER\r\n===================================================== */\r\n\r\n.candidate-header{\r\n    display:flex;\r\n    justify-content:space-between;\r\n    align-items:center;\r\n    padding:10px;\r\n    color:#fff;\r\n    background:\r\n        linear-gradient(\r\n            135deg,\r\n            #2563EB,\r\n            #4F46E5\r\n        );\r\n    position:sticky;\r\n    top:0;\r\n    z-index:30;\r\n}\r\n\r\n.candidate-header::after{\r\n    content:\"\";\r\n    position:absolute;\r\n    width:210px;\r\n    height:210px;\r\n    border-radius:50%;\r\n    right:-80px;\r\n    top:-120px;\r\n    background: rgba(255,255,255,.08);\r\n}\r\n\r\n.candidate-header h2{\r\n    font-size:24px;\r\n    font-weight:700;\r\n    margin:0;\r\n    letter-spacing:.3px;\r\n}\r\n\r\n.candidate-header p{\r\n    margin-top:8px;\r\n    font-size:15px;\r\n    opacity:.9;\r\n}\r\n\r\n.candidate-header-icon{\r\n    width:50px;\r\n    height:50PX;\r\n    border-radius:20px;\r\n    display:flex;\r\n    justify-content:center;\r\n    align-items:center;\r\n    background:rgba(255,255,255,.15);\r\n    backdrop-filter:blur(15px);\r\n    font-size:24px;\r\n    animation:floatIcon 3s ease infinite;\r\n}\r\n\r\n/* =====================================================\r\n   FORM\r\n===================================================== */\r\n\r\nform{\r\n    padding:6px;\r\n}\r\n\r\n/* =====================================================\r\n   SECTION\r\n===================================================== */\r\n\r\n.section{\r\n    margin-bottom:24px;\r\n    background:#fff;\r\n    border:1px solid var(--border);\r\n    border-radius:18px;\r\n    padding:14px;\r\n    transition:.3s;\r\n}\r\n\r\n.section:hover{\r\n    transform:translateY(-2px);\r\n    box-shadow: 0 12px 28px rgba(37,99,235,.08);\r\n}\r\n\r\n/* =====================================================\r\n   SECTION TITLE\r\n===================================================== */\r\n\r\n.section-title{\r\n    display:flex;\r\n    align-items:center;\r\n    gap:12px;\r\n    margin-bottom:22px;\r\n    font-size:19px;\r\n    font-weight:700;\r\n    color:var(--text);\r\n    position:relative;\r\n    padding-bottom:14px;\r\n}\r\n\r\n.section-title svg{\r\n    font-size:22px;\r\n    color:var(--primary);\r\n}\r\n\r\n.section-title::after{\r\n    content:\"\";\r\n    position:absolute;\r\n    bottom:0;\r\n    left:0;\r\n    width:70px;\r\n    height:4px;\r\n    border-radius:10px;\r\n    background:\r\n        linear-gradient(\r\n            90deg,\r\n            var(--primary),\r\n            var(--secondary)\r\n        );\r\n}\r\n\r\n/* =====================================================\r\n   GRID\r\n===================================================== */\r\n\r\n.candidate-grid{\r\n    display:grid;\r\n    grid-template-columns:  repeat(3,minmax(280px,1fr));\r\n    gap:12px;\r\n}\r\n\r\n/* =====================================================\r\n   FORM GROUP\r\n===================================================== */\r\n\r\n.form-group{\r\n    display:flex;\r\n    flex-direction:column;\r\n    margin-bottom:20px;\r\n}\r\n\r\n.form-group label{\r\n    font-size:14px;\r\n    font-weight:600;\r\n    color:var(--text);\r\n    margin-bottom:10px;\r\n    letter-spacing:.3px;\r\n}\r\n\r\n/* =====================================================\r\n   FIELD INFO\r\n===================================================== */\r\n\r\n.field-info{\r\n    margin-top:8px;\r\n    color:var(--text-light);\r\n    font-size:13px;\r\n}\r\n\r\n/* =====================================================\r\n   SMALL ERROR\r\n===================================================== */\r\n\r\n.form-group small{\r\n    display:flex;\r\n    align-items:center;\r\n    gap:6px;\r\n    margin-top:8px;\r\n    color:var(--danger);\r\n    font-size:13px;\r\n    font-weight:500;\r\n}\r\n\r\n/* =====================================================\r\n   ANIMATIONS\r\n===================================================== */\r\n\r\n@keyframes pageFade{\r\n    from{\r\n        opacity:0;\r\n        transform:translateY(25px);\r\n    }\r\n    to{\r\n        opacity:1;\r\n        transform:translateY(0);\r\n    }\r\n}\r\n\r\n@keyframes floatIcon{\r\n    0%{\r\n        transform:translateY(0);\r\n    }\r\n    50%{\r\n        transform:translateY(-6px);\r\n    }\r\n    100%{\r\n        transform:translateY(0);\r\n    }\r\n\r\n}\r\n\r\n/* =====================================================\r\n   PART 3.2\r\n   INPUTS • SELECT • TEXTAREA\r\n===================================================== */\r\n\r\n/* INPUT CONTAINER */\r\n\r\n.input-box{\r\n    position:relative;\r\n    display:flex;\r\n    align-items:center;\r\n    width:100%;\r\n}\r\n\r\n/* INPUT ICON */\r\n\r\n.input-box svg{\r\n    position:absolute;\r\n    left:16px;\r\n    top:50%;\r\n    transform:translateY(-50%);\r\n    color:#94A3B8;\r\n    font-size:18px;\r\n    transition:.3s;\r\n    pointer-events:none;\r\n    z-index:2;\r\n}\r\n\r\n/* INPUT */\r\n\r\n.input-box input{\r\n    width:100%;\r\n    height:34px;\r\n    border:1px solid var(--border);\r\n    border-radius:8px;\r\n    background:#fff;\r\n    padding:0 18px 0 48px;\r\n    font-size:15px;\r\n    color:var(--text);\r\n    outline:none;\r\n    transition:all .30s ease;\r\n}\r\n\r\n/* SELECT */\r\n\r\n.input-box select{\r\n    width:100%;\r\n    height:34px;\r\n    border:1px solid var(--border);\r\n    border-radius:8px;\r\n    background:#fff;\r\n    padding:0 18px 0 48px;\r\n    font-size:15px;\r\n    color:var(--text);\r\n    outline:none;\r\n    cursor:pointer;\r\n    appearance:none;\r\n    -webkit-appearance:none;\r\n    transition:all .30s ease;\r\n}\r\n\r\n/* TEXTAREA WRAPPER */\r\n\r\n.textarea-box{\r\n    align-items:flex-start;\r\n}\r\n\r\n/* TEXTAREA ICON */\r\n\r\n.textarea-icon{\r\n    position:absolute;\r\n    left:16px;\r\n    top:18px !important;\r\n    transform:none !important;\r\n    color:#94A3B8;\r\n    font-size:18px;\r\n}\r\n\r\n/* TEXTAREA */\r\n\r\n.textarea-box textarea{\r\n    width:100%;\r\n    height:40px;\r\n    resize:vertical;\r\n    border:1px solid var(--border);\r\n    border-radius:14px;\r\n    background:#fff;\r\n    padding:16px 18px 16px 48px;\r\n    font-size:15px;\r\n    line-height:1.7;\r\n    color:var(--text);\r\n    outline:none;\r\n    transition:.30s;\r\n    font-family:inherit;\r\n}\r\n\r\n/* REMARKS TEXTAREA */\r\n\r\n.form-group textarea{\r\n    width:100%;\r\n    min-height:140px;\r\n    border:1px solid var(--border);\r\n    border-radius:14px;\r\n    padding:16px;\r\n    resize:vertical;\r\n    font-size:15px;\r\n    line-height:1.7;\r\n    color:var(--text);\r\n    outline:none;\r\n    transition:.30s;\r\n    font-family:inherit;\r\n\r\n}\r\n\r\n/* PLACEHOLDER */\r\n\r\n.input-box input::placeholder,\r\n.textarea-box textarea::placeholder,\r\n.form-group textarea::placeholder{\r\n    color:#94A3B8;\r\n}\r\n\r\n/* HOVER */\r\n\r\n.input-box input:hover,\r\n.input-box select:hover,\r\n.textarea-box textarea:hover,\r\n.form-group textarea:hover{\r\n    border-color:#BFDBFE;\r\n}\r\n\r\n/* FOCUS */\r\n.input-box input:focus,\r\n.input-box select:focus,\r\n.textarea-box textarea:focus,\r\n.form-group textarea:focus{\r\n    border-color:var(--primary);\r\n    box-shadow:0 0 0 5px rgba(37,99,235,.12);\r\n}\r\n\r\n/* ICON COLOR ON FOCUS */\r\n\r\n.input-box:focus-within svg{\r\n    color:var(--primary);\r\n}\r\n\r\n/* ERROR INPUT */\r\n.input-error input,\r\n.input-error select,\r\n.input-error textarea{\r\n    border-color:var(--danger);\r\n    box-shadow:0 0 0 4px rgba(239,68,68,.12);\r\n\r\n}\r\n\r\n/* REQUIRED STAR */\r\n.required{\r\n    color:var(--danger);\r\n    margin-left:4px;\r\n}\r\n\r\n/* CHARACTER COUNTER */\r\n\r\n.remarks-count{\r\n    margin-top:8px;\r\n    text-align:right;\r\n    color:var(--text-light);\r\n    font-size:13px;\r\n}\r\n\r\n/* DISABLED */\r\n\r\ninput:disabled,\r\ntextarea:disabled,\r\nselect:disabled{\r\n    background:#F8FAFC;\r\n    color:#94A3B8;\r\n    cursor:not-allowed;\r\n}\r\n\r\n/* AUTOFILL */\r\ninput:-webkit-autofill{\r\n    -webkit-box-shadow:0 0 0px 1000px white inset;\r\n    -webkit-text-fill-color:var(--text);\r\n}\r\n\r\n/* LABEL ANIMATION */\r\n\r\n.form-group label{\r\n    transition:.25s;\r\n}\r\n\r\n.form-group:hover label{\r\n    color:var(--primary);\r\n}\r\n\r\n/* SMOOTH FIELD APPEAR */\r\n\r\n.form-group{\r\n    animation:fieldFade .45s ease;\r\n}\r\n\r\n@keyframes fieldFade{\r\n    from{\r\n        opacity:0;\r\n        transform:translateY(10px);\r\n    }\r\n    to{\r\n        opacity:1;\r\n        transform:translateY(0);\r\n    }\r\n}\r\n\r\n/* MOBILE */\r\n\r\n@media(max-width:768px){\r\n    .candidate-grid{\r\n        grid-template-columns:1fr;\r\n    }\r\n\r\n    .input-box input,\r\n    .input-box select{\r\n        height:50px;\r\n    }\r\n}\r\n\r\n/* =====================================================\r\n   PART 3.3\r\n   RESUME UPLOAD\r\n===================================================== */\r\n\r\n/* Resume Upload Container */\r\n.upload-box{\r\n    width:100%;\r\n    min-height:260px;\r\n    border:2px dashed #3B82F6;\r\n    border-radius:20px;\r\n    background:linear-gradient(180deg, #F8FBFF, #EFF6FF);\r\n    display:flex;\r\n    justify-content:center;\r\n    align-items:center;\r\n    cursor:pointer;\r\n    transition:all .35s ease;\r\n    position:relative;\r\n    overflow:hidden;\r\n}\r\n\r\n/* Background Glow */\r\n\r\n.upload-box::before{\r\n    content:\"\";\r\n    position:absolute;\r\n    inset:0;\r\n    background:radial-gradient(circle at top right, rgba(59,130,246,.12), transparent 55%);\r\n    opacity:0;\r\n    transition:.35s;\r\n}\r\n\r\n.upload-box:hover{\r\n    transform:translateY(-4px);\r\n    border-color:var(--secondary);\r\n    box-shadow:0 18px 45px rgba(37,99,235,.15);\r\n}\r\n\r\n.upload-box:hover::before{\r\n    opacity:1;\r\n}\r\n\r\n/* Drag Active */\r\n\r\n.upload-box.active{\r\n    border-color:var(--success);\r\n    background:#ECFDF5;\r\n    transform:scale(1.01);\r\n}\r\n\r\n/* Upload Content */\r\n\r\n.upload-content{\r\n    display:flex;\r\n    flex-direction:column;\r\n    justify-content:center;\r\n    align-items:center;\r\n    text-align:center;\r\n    z-index:2;\r\n    padding:35px;\r\n}\r\n\r\n/* Upload Circle */\r\n\r\n.upload-circle{\r\n    width:82px;\r\n    height:82px;\r\n    border-radius:50%;\r\n    display:flex;\r\n    justify-content:center;\r\n    align-items:center;\r\n    background:linear-gradient(135deg, var(--primary), var(--secondary));\r\n    color:#fff;\r\n    font-size:34px;\r\n    margin-bottom:22px;\r\n    animation:uploadFloat 3s ease infinite;\r\n}\r\n\r\n/* Upload Heading */\r\n\r\n.upload-content h3{\r\n    font-size:22px;\r\n    font-weight:700;\r\n    color:var(--text);\r\n    margin-bottom:10px;\r\n}\r\n\r\n/* Upload Description */\r\n\r\n.upload-content p{\r\n    color:var(--text-light);\r\n    font-size:15px;\r\n    margin-bottom:6px;\r\n\r\n}\r\n\r\n/* Browse Text */\r\n\r\n.upload-content span{\r\n\r\n    color:var(--primary);\r\n\r\n    font-weight:600;\r\n\r\n    font-size:14px;\r\n\r\n}\r\n\r\n/* Selected File */\r\n\r\n.selected-file{\r\n\r\n    margin-top:24px;\r\n\r\n    display:flex;\r\n\r\n    align-items:center;\r\n\r\n    gap:10px;\r\n\r\n    background:#fff;\r\n\r\n    border:1px solid #D1FAE5;\r\n\r\n    color:var(--success);\r\n\r\n    padding:14px 20px;\r\n\r\n    border-radius:14px;\r\n\r\n    box-shadow:0 8px 20px rgba(16,185,129,.08);\r\n\r\n    font-weight:600;\r\n\r\n    max-width:100%;\r\n\r\n    word-break:break-word;\r\n\r\n}\r\n\r\n.selected-file svg{\r\n\r\n    font-size:20px;\r\n\r\n}\r\n\r\n/* Error Message */\r\n\r\n.upload-content small{\r\n\r\n    display:flex;\r\n\r\n    align-items:center;\r\n\r\n    gap:8px;\r\n\r\n    margin-top:18px;\r\n\r\n    color:var(--danger);\r\n\r\n    font-size:14px;\r\n\r\n    font-weight:600;\r\n\r\n}\r\n\r\n/* =====================================================\r\n   CURRENT RESUME CARD\r\n===================================================== */\r\n\r\n.current-resume{\r\n\r\n    margin-bottom:22px;\r\n\r\n    border:1px solid var(--border);\r\n\r\n    border-left:5px solid var(--primary);\r\n\r\n    border-radius:16px;\r\n\r\n    background:#fff;\r\n\r\n    padding:18px 22px;\r\n\r\n    transition:.3s;\r\n\r\n}\r\n\r\n.current-resume:hover{\r\n\r\n    transform:translateY(-2px);\r\n\r\n    box-shadow:0 10px 25px rgba(37,99,235,.08);\r\n\r\n}\r\n\r\n.resume-left{\r\n\r\n    display:flex;\r\n\r\n    align-items:center;\r\n\r\n    gap:16px;\r\n\r\n}\r\n\r\n.resume-left svg{\r\n\r\n    font-size:28px;\r\n\r\n    color:var(--success);\r\n\r\n}\r\n\r\n.resume-left h4{\r\n\r\n    margin:0;\r\n\r\n    color:var(--text);\r\n\r\n    font-size:17px;\r\n\r\n    font-weight:700;\r\n\r\n}\r\n\r\n.resume-left span{\r\n\r\n    display:block;\r\n\r\n    margin-top:5px;\r\n\r\n    color:var(--text-light);\r\n\r\n    font-size:14px;\r\n\r\n    word-break:break-all;\r\n\r\n}\r\n\r\n/* =====================================================\r\n   UPLOAD FLOAT ANIMATION\r\n===================================================== */\r\n\r\n@keyframes uploadFloat{\r\n\r\n    0%{\r\n\r\n        transform:translateY(0);\r\n\r\n    }\r\n\r\n    50%{\r\n\r\n        transform:translateY(-8px);\r\n\r\n    }\r\n\r\n    100%{\r\n\r\n        transform:translateY(0);\r\n\r\n    }\r\n\r\n}\r\n\r\n/* =====================================================\r\n   MOBILE\r\n===================================================== */\r\n\r\n@media(max-width:768px){\r\n\r\n    .upload-box{\r\n\r\n        min-height:220px;\r\n\r\n    }\r\n\r\n    .upload-circle{\r\n\r\n        width:68px;\r\n\r\n        height:68px;\r\n\r\n        font-size:28px;\r\n\r\n    }\r\n\r\n    .upload-content h3{\r\n\r\n        font-size:19px;\r\n\r\n    }\r\n\r\n}\r\n\r\n/* =====================================================\r\n   PART 3.4\r\n   FOOTER • BUTTONS • LOADER • RESPONSIVE\r\n===================================================== */\r\n\r\n/* ==========================\r\n   FOOTER\r\n========================== */\r\n\r\n.candidate-footer{\r\n\r\n    position:sticky;\r\n\r\n    bottom:0;\r\n\r\n    background:#fff;\r\n\r\n    padding:20px 28px;\r\n\r\n    margin:30px -28px -28px;\r\n\r\n    border-top:1px solid var(--border);\r\n\r\n    display:flex;\r\n\r\n    justify-content:flex-end;\r\n\r\n    align-items:center;\r\n\r\n    gap:16px;\r\n\r\n    z-index:20;\r\n\r\n}\r\n\r\n/* ==========================\r\n   BUTTONS\r\n========================== */\r\n\r\n.cancel-btn{\r\n\r\n    min-width:150px;\r\n\r\n    height:48px;\r\n\r\n    border:1px solid var(--border);\r\n\r\n    background:#fff;\r\n\r\n    color:var(--text);\r\n\r\n    border-radius:14px;\r\n\r\n    font-size:15px;\r\n\r\n    font-weight:600;\r\n\r\n    cursor:pointer;\r\n\r\n    transition:all .30s ease;\r\n\r\n}\r\n\r\n.cancel-btn:hover{\r\n\r\n    background:#F8FAFC;\r\n\r\n    border-color:#CBD5E1;\r\n\r\n    transform:translateY(-2px);\r\n\r\n}\r\n\r\n.save-btn{\r\n\r\n    min-width:190px;\r\n\r\n    height:48px;\r\n\r\n    border:none;\r\n\r\n    border-radius:14px;\r\n\r\n    background:linear-gradient(\r\n        135deg,\r\n        var(--primary),\r\n        var(--secondary)\r\n    );\r\n\r\n    color:#fff;\r\n\r\n    display:flex;\r\n\r\n    justify-content:center;\r\n\r\n    align-items:center;\r\n\r\n    gap:10px;\r\n\r\n    font-size:15px;\r\n\r\n    font-weight:700;\r\n\r\n    cursor:pointer;\r\n\r\n    transition:all .30s ease;\r\n\r\n    box-shadow:\r\n        0 10px 25px rgba(37,99,235,.25);\r\n\r\n}\r\n\r\n.save-btn:hover{\r\n\r\n    transform:translateY(-3px);\r\n\r\n    box-shadow:\r\n        0 18px 40px rgba(37,99,235,.35);\r\n\r\n}\r\n\r\n.save-btn:active{\r\n\r\n    transform:scale(.98);\r\n\r\n}\r\n\r\n.save-btn:disabled{\r\n\r\n    opacity:.7;\r\n\r\n    cursor:not-allowed;\r\n\r\n    transform:none;\r\n\r\n}\r\n\r\n/* ==========================\r\n   LOADER\r\n========================== */\r\n\r\n.loader{\r\n\r\n    width:18px;\r\n\r\n    height:18px;\r\n\r\n    border:2px solid rgba(255,255,255,.35);\r\n\r\n    border-top:2px solid #fff;\r\n\r\n    border-radius:50%;\r\n\r\n    animation:spin .8s linear infinite;\r\n\r\n}\r\n\r\n@keyframes spin{\r\n\r\n    from{\r\n\r\n        transform:rotate(0deg);\r\n\r\n    }\r\n\r\n    to{\r\n\r\n        transform:rotate(360deg);\r\n\r\n    }\r\n\r\n}\r\n\r\n/* ==========================\r\n   SMOOTH SCROLL\r\n========================== */\r\n\r\n.candidate-card{\r\n\r\n    scroll-behavior:smooth;\r\n\r\n}\r\n\r\n/* Optional visible scrollbar */\r\n\r\n.candidate-card::-webkit-scrollbar{\r\n\r\n    width:8px;\r\n\r\n}\r\n\r\n.candidate-card::-webkit-scrollbar-track{\r\n\r\n    background:#F8FAFC;\r\n\r\n}\r\n\r\n.candidate-card::-webkit-scrollbar-thumb{\r\n\r\n    background:#CBD5E1;\r\n\r\n    border-radius:10px;\r\n\r\n}\r\n\r\n.candidate-card::-webkit-scrollbar-thumb:hover{\r\n\r\n    background:#94A3B8;\r\n\r\n}\r\n\r\n/* ==========================\r\n   FADE-IN ANIMATION\r\n========================== */\r\n\r\n.section{\r\n\r\n    animation:sectionFade .45s ease both;\r\n\r\n}\r\n\r\n.section:nth-child(2){\r\n\r\n    animation-delay:.05s;\r\n\r\n}\r\n\r\n.section:nth-child(3){\r\n\r\n    animation-delay:.10s;\r\n\r\n}\r\n\r\n.section:nth-child(4){\r\n\r\n    animation-delay:.15s;\r\n\r\n}\r\n\r\n@keyframes sectionFade{\r\n\r\n    from{\r\n\r\n        opacity:0;\r\n\r\n        transform:translateY(18px);\r\n\r\n    }\r\n\r\n    to{\r\n\r\n        opacity:1;\r\n\r\n        transform:translateY(0);\r\n\r\n    }\r\n\r\n}\r\n\r\n/* ==========================\r\n   RESPONSIVE\r\n========================== */\r\n\r\n@media (max-width:992px){\r\n\r\n    .candidate-card{\r\n\r\n        width:100%;\r\n\r\n        height:calc(100vh - 40px);\r\n\r\n        border-radius:18px;\r\n\r\n    }\r\n\r\n    .candidate-header{\r\n\r\n        padding:24px;\r\n\r\n    }\r\n\r\n    .candidate-header h2{\r\n\r\n        font-size:28px;\r\n\r\n    }\r\n\r\n}\r\n\r\n@media (max-width:768px){\r\n\r\n    .candidate-page{\r\n\r\n        padding:12px;\r\n\r\n    }\r\n\r\n    .candidate-header{\r\n\r\n        flex-direction:column;\r\n\r\n        align-items:flex-start;\r\n\r\n        gap:16px;\r\n\r\n    }\r\n\r\n    .candidate-header-icon{\r\n\r\n        width:64px;\r\n\r\n        height:64px;\r\n\r\n        font-size:30px;\r\n\r\n    }\r\n\r\n    .candidate-grid{\r\n\r\n        grid-template-columns:1fr;\r\n\r\n    }\r\n\r\n    .candidate-footer{\r\n\r\n        flex-direction:column-reverse;\r\n\r\n        align-items:stretch;\r\n\r\n        gap:12px;\r\n\r\n    }\r\n\r\n    .cancel-btn,\r\n\r\n    .save-btn{\r\n\r\n        width:100%;\r\n\r\n    }\r\n\r\n}\r\n\r\n@media (max-width:480px){\r\n\r\n    form{\r\n\r\n        padding:18px;\r\n\r\n    }\r\n\r\n    .section{\r\n\r\n        padding:18px;\r\n\r\n    }\r\n\r\n    .candidate-header h2{\r\n\r\n        font-size:24px;\r\n\r\n    }\r\n\r\n    .candidate-header p{\r\n\r\n        font-size:13px;\r\n\r\n    }\r\n\r\n    .section-title{\r\n\r\n        font-size:17px;\r\n\r\n    }\r\n\r\n}\r\n\r\n/* ==========================\r\n   BUTTON RIPPLE EFFECT\r\n========================== */\r\n\r\n.save-btn,\r\n\r\n.cancel-btn{\r\n\r\n    position:relative;\r\n\r\n    overflow:hidden;\r\n\r\n}\r\n\r\n.save-btn::after,\r\n\r\n.cancel-btn::after{\r\n\r\n    content:\"\";\r\n\r\n    position:absolute;\r\n\r\n    width:0;\r\n\r\n    height:0;\r\n\r\n    background:rgba(255,255,255,.25);\r\n\r\n    border-radius:50%;\r\n\r\n    transform:translate(-50%,-50%);\r\n\r\n    transition:width .5s,height .5s;\r\n\r\n    left:50%;\r\n\r\n    top:50%;\r\n\r\n}\r\n\r\n.save-btn:active::after,\r\n\r\n.cancel-btn:active::after{\r\n\r\n    width:320px;\r\n\r\n    height:320px;\r\n\r\n}\r\n\r\n/* ==========================\r\n   CARD HOVER\r\n========================== */\r\n\r\n.candidate-card{\r\n\r\n    transition:transform .35s ease,\r\n\r\n               box-shadow .35s ease;\r\n\r\n}\r\n\r\n.candidate-card:hover{\r\n\r\n    transform:translateY(-3px);\r\n\r\n}\r\n\r\n/* ==========================\r\n   FINISH\r\n========================== */\n.candidate-submit-error {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin: 18px 24px 0;\n    padding: 12px 14px;\n    border: 1px solid #fecaca;\n    border-radius: 10px;\n    background: #fef2f2;\n    color: #b91c1c;\n    font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
